

import React, { useState, useEffect, useRef } from 'react';
import PaymentSuccessGif from '../../assets/Images/PaymentSuccess.gif';
import returnicon from '../../assets/Images/returnicon.svg';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { useNavigate } from 'react-router-dom';
import { Postdata } from '../../API/GlobalApi';
// import { postDataWithToken } from '../../API/GlobalApi';
import logoPdf from '../../assets/Images/arctLogo-removebg-preview.png'
import { PostdataformPublic } from '../../../../API/GlobalApi';
export const PaymentSuccessPageArct = () => {
  const [transactionId, setTransactionId] = useState('');
  const [studentId, setStudentId] = useState('');
  const [paymentData, setPaymentData] = useState(null);
  const tableRef = useRef();



  const navigate = useNavigate()
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const txnId = params.get('transaction_id');
    const stdId = params.get('student_id');
    setTransactionId(txnId);
    setStudentId(stdId);

    if (txnId && stdId) {
      const token = sessionStorage.getItem('student_auth_token');
      const url = 'contest-admission-payment-status/';
      const finalObj = { transaction_id: txnId, student_id: stdId };

      Postdata(url, finalObj, token)
        .then(data => {
          console.log('✅ Payment status updated:', data);
          setPaymentData(data);
        })
        .catch(error => {
          console.error('❌ Error updating payment status:', error);
        });
    }
  }, []);
  const downloadPDF = () => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const logo = new Image();
    logo.src = logoPdf;

    logo.onload = () => {
      const logoWidth = 60;
      const aspectRatio = logo.height / logo.width;
      const logoHeight = logoWidth * aspectRatio;
      const logoX = (pageWidth - logoWidth) / 2;
      const logoY = 10; // add a little top margin

      // Add image
      doc.addImage(logo, 'PNG', logoX, logoY, logoWidth, logoHeight);

      // Add title **with proper spacing below the logo**
      const spacingAfterLogo = 10; // space in pts between logo and title
      const titleY = logoY + logoHeight + spacingAfterLogo;

      doc.setFont('helvetica', 'bold');
      doc.setFontSize(16);
      doc.setTextColor('#222');
      doc.text('Registration Receipt', pageWidth / 2, titleY, { align: 'center' });

      // Divider line
      const dividerY = titleY + 5;
      doc.setDrawColor(150);
      doc.setLineWidth(0.5);
      doc.line(40, dividerY, pageWidth - 40, dividerY);

      // Payment data
      const data = [
        ['Name.', paymentData?.student_name],
        ['Phone No.', paymentData?.registered_phone_number],
        ['Payment Status', paymentData?.status],
        ['Form No.', paymentData?.roll_numnber],
        ['Transaction ID', paymentData?.transaction_id],
        ['EasePay ID', paymentData?.easepayid],
        ['Mode of Payment', paymentData?.mode_of_payment],
        ['Payment Date', new Date(paymentData?.payment_date).toLocaleString()],
        ['Amount', `${paymentData?.amount}`]
      ];

      const labelX = 50;
      const valueX = 120;
      let y = dividerY + 10; // start below divider

      data.forEach(([label, value]) => {
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(12);
        doc.text(label, labelX, y);
        doc.text(String(value), valueX, y);
        y += 12;
      });

      doc.save(`payment-details-${paymentData?.transaction_id}.pdf`);
    };
  };


  const generatePdfBlob = async () => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();

    const logo = new Image();
    logo.src = logoPdf;

    return new Promise((resolve) => {
      logo.onload = () => {
        const logoWidth = 60;
        const aspectRatio = logo.height / logo.width;
        const logoHeight = logoWidth * aspectRatio;
        const logoX = (pageWidth - logoWidth) / 2;

        doc.addImage(logo, 'PNG', logoX, 10, logoWidth, logoHeight);

        const titleY = 10 + logoHeight + 10;
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(16);
        doc.text('Registration Receipt', pageWidth / 2, titleY, { align: 'center' });

        const dividerY = titleY + 5;
        doc.line(40, dividerY, pageWidth - 40, dividerY);

        const rows = [
          ['Name', paymentData.student_name],
          ['Phone', paymentData.registered_phone_number],
          ['Form No.', paymentData.roll_numnber],
          ['Transaction ID', paymentData.transaction_id],
          ['Payment Mode', paymentData.mode_of_payment],
          ['Payment Date', new Date(paymentData.payment_date).toLocaleString()],
          ['Amount', `RS ${paymentData.amount}`]
        ];

        let y = dividerY + 10;
        rows.forEach(([k, v]) => {
          doc.setFontSize(12);
          doc.text(k, 50, y);
          doc.text(String(v), 120, y);
          y += 12;
        });

        // 🔥 IMPORTANT: return blob instead of saving
        const pdfBlob = doc.output('blob');
        resolve(pdfBlob);
      };
    });
  };




  const whatsappTriggeredRef = useRef(false);

  useEffect(() => {
    if (!paymentData) return;
    if (whatsappTriggeredRef.current) return;

    whatsappTriggeredRef.current = true;

    const sendWhatsappWithPdf = async () => {
      try {
        const token = sessionStorage.getItem('student_auth_token');

        // 1️⃣ Generate PDF
        const pdfBlob = await generatePdfBlob();

        // 2️⃣ Prepare FormData
        const formData = new FormData();
        formData.append(
          'document_url',
          pdfBlob,
          `${paymentData.roll_numnber}.pdf` // 👈 roll number as filename
        );
        formData.append('participant_roll_number', paymentData.roll_numnber);


        // 3️⃣ Send WhatsApp API
      const response =  await PostdataformPublic(
          'administration/send-registration-successful-whatsapp/',
          formData,

        );
        console.log("responses in senting messges",response)

        console.log('📄 WhatsApp PDF sent successfully');
      } catch (err) {
        console.error('❌ WhatsApp document send failed', err);
      }
    };

    sendWhatsappWithPdf();
  }, [paymentData]);



  return (
    <div style={styles.pageContainer}>
      <div style={styles.card}>
        <img src={PaymentSuccessGif} alt="Payment Success" style={styles.gif} />
        <h2 style={styles.successText} >Your Payment is Successful!</h2>

        {/* {transactionId && <p><b>Transaction ID:</b> {transactionId}</p>} */}

        <p style={styles.description}>
          {/* Thank you for completing the provisional admission process. We are pleased to inform you that your application has been successfully registered and is currently under review by our admissions team. You will be notified as soon as your admission is confirmed. */}
        </p>

        {paymentData && (
          <>
            <div ref={tableRef} style={styles.tableWrapper}>
              <table style={styles.table}>
                <tbody>
                  <tr><th>Name.</th><td>{paymentData.student_name}</td></tr>
                  <tr><th>Phone no.</th><td>{paymentData.registered_phone_number}</td></tr>
                  <tr><th>Form  No.</th><td>{paymentData.roll_numnber}</td></tr>
                  <tr><th>Transaction ID</th><td>{paymentData.transaction_id}</td></tr>
                  <tr><th>EasePay ID</th><td>{paymentData.easepayid}</td></tr>
                  <tr><th>Mode of Payment</th><td>{paymentData.mode_of_payment}</td></tr>
                  <tr><th>Payment Date</th><td>{new Date(paymentData.payment_date).toLocaleString()}</td></tr>
                  <tr><th>Amount</th><td>₹ {paymentData.amount}</td></tr>
                </tbody>
              </table>
            </div>
            <button onClick={downloadPDF} style={{ ...styles.button, marginTop: 10 }}>
              Download as PDF
            </button>
          </>
        )}

        <button
          style={{ ...styles.button, marginTop: '20px', marginLeft: "20px" }}
          onClick={() => navigate('/arct')}
        >
          Return to Home <img src={returnicon} alt="return" />
        </button>
      </div>
    </div>
  );
};

const styles = {
  pageContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    backgroundColor: '#f5f8ff',
    padding: '1rem',
  },
  card: {
    backgroundColor: '#ffffff',
    borderRadius: '20px',
    padding: '40px',
    width: '100%',
    maxWidth: '700px',
    textAlign: 'center',
    boxShadow: '0 0 30px rgba(0,0,0,0.05)',
  },
  gif: {
    height: '180px',
    marginBottom: '20px',
  },
  successText: {
    color: '#DE0949',
    marginBottom: '10px',
  },
  description: {
    color: '#555',
    fontSize: '16px',
    marginBottom: '30px',
  },
  button: {
    backgroundColor: '#DE0949',

    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    padding: '12px 24px',
    fontWeight: 400,
    fontSize: '16px',
    cursor: 'pointer',
  },
  tableWrapper: {
    marginTop: '20px',
    marginBottom: '20px',
    textAlign: 'left',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '15px',
  },
  th: {
    textAlign: 'left',
    backgroundColor: '#f1f1f1',
  },
};
